import { useEffect, useMemo } from 'react'
import { updateTeacherInfo } from '../../../redux/states/docente'
import { useDispatch, useSelector } from 'react-redux'
import { PrivateRoutes } from 'routes/rutas'
import { generateRandomCode, openWindowNotification } from './logic'
import { useSchedule } from '../../../hooks/useSchedule'
import { useTicket } from '../../../hooks/useTicket'
import { minutesToEndClass } from 'data/constants'
import { addTime, formatDate } from 'utils'
import { decryptAES } from 'utils/encryptionUtils/decryptAES'
import { useNavigate } from 'react-router-dom'
import { useServerDate } from 'hooks/useServerDate'

let throwEndClass = false

/**
 * Componente encargado de controlar las notificaciones.
 * Se encuentra por separado para que las solo este componente se actualice.
 * @returns {JSX.Element} Retorna el componente ControlNotificaciones
 */
export function ControlNotificaciones() {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { activeNotification, classStarted, infoTimer, infoSchedule } = useSelector((store) => store.teacher)
    const { serverDate, timeString, dateString, dateTimeString } = useServerDate()
    const { getDailySchedules, duracionNotificaciones } = useSchedule()
    const { sendEndClass } = useTicket()

    const endTimePlusSlack = useMemo(() => {
        if (classStarted.active) {
            const endTime = infoSchedule?.schedule?.hora_fin
            return formatDate(addTime(`${dateString} ${endTime}`, minutesToEndClass, 'minutes'), 'H:i:s', null)
        } else {
            return null
        }
    }, [classStarted.active])

    useEffect(() => {
        validateEndDate()
        validateRegistrationTime()
        validateCounterTime()
        validateCurrentClass()
    }, [timeString])

    /** Controla que si la clase no se inicia y pasa la hora de fin, actualiza a la siguiente clase. */
    const validateCurrentClass = () => {
        if (infoSchedule.schedule && !classStarted.active) {
            if (timeString > infoSchedule.schedule.hora_fin) {
                getDailySchedules()
            }
        }
    }
    /** Controla que pasado el temporizador desaparezca el captcha. */
    const validateCounterTime = () => {
        if (Object.keys(infoTimer).length === 0) {
            if (classStarted.active && activeNotification) {
                dispatch(updateTeacherInfo({ activeNotification: false }))
            }
        } else {
            const timeToClose = `${dateString} ${infoTimer.time}`
            if (dateTimeString > timeToClose && activeNotification) {
                dispatch(updateTeacherInfo({ activeNotification: false }))
            }
        }
    }
    /** Abre una ventana cuando llegue el momento de tiquear. */
    const validateRegistrationTime = () => {
        if (Object.keys(infoSchedule).length === 0 || infoSchedule.notificationSchedules?.length === 0) return

        if (!activeNotification) {
            const notificationsJson = decryptAES(infoSchedule.notificationSchedules)
            const notifications = JSON.parse(notificationsJson)
            const notification = notifications.find((n) => n.hora.slice(0, 5) === timeString.slice(0, 5))

            if (notification && !notification.tikeo) {
                startTimer(generateRandomCode(3), notification)
                openWindowNotification(PrivateRoutes.CONTROLPERMANENCIA)
            }
        }
    }

    /** Valida la hora de finalizacion de la materia. */
    const validateEndDate = async () => {
        if (classStarted.active) {
            if (endTimePlusSlack && timeString >= endTimePlusSlack && !throwEndClass) {
                throwEndClass = true
                await sendEndClass({
                    descripcion: 'Clase finalizada por el sistema.',
                    tickeo: false,
                })
                navigate(PrivateRoutes.REPORTETEACHER)
                await getDailySchedules()
                throwEndClass = false
            }
        }
    }

    /** Genera el tiempo de espera antes del cierre del captcha. */
    const startTimer = (codeRandom, infoNotification) => {
        const newTime = formatDate(addTime(serverDate.current, duracionNotificaciones, 'minutes'), 'H:i:s')
        const timeRemaning =
            duracionNotificaciones < 10 ? `0${duracionNotificaciones}:00` : `${duracionNotificaciones}:00`
        const infoTimer = {
            infoTimer: {
                active: true,
                time: newTime,
                code: codeRandom,
                timeRemaning,
                id: infoNotification.id,
            },
            activeNotification: true,
        }
        dispatch(updateTeacherInfo(infoTimer))
    }

    return null
}
